import React from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import { withI18n } from '../../hocs'
import ActionDialog from '../action-dialog'
import * as S from './styled'

// Confirmación simple sobre ActionDialog
const AlertDialog = ({ text, title, onSuccess, onClose, open, i18n }) => (
  <ActionDialog
    open={open}
    title={title}
    onClose={onClose}
    onConfirm={onSuccess}
    cancelLabel={i18n.dialog.decline}
    confirmLabel={i18n.dialog.success}
  >
    <S.Text>{text}</S.Text>
  </ActionDialog>
)

AlertDialog.propTypes = {
  i18n: PropTypes.object.isRequired,
  text: PropTypes.string,
  title: PropTypes.string,
  onSuccess: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool
}

AlertDialog.defaultProps = {
  open: false
}

const enharce = compose(withI18n)

export default enharce(AlertDialog)
